"use strict";

require("core-js/es6/map");

require("core-js/es6/set");


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/gatsby-browser.js
// module id = 1484
// module chunks = 231608221292675